module.exports = __webpack_public_path__ + "img/shiba-body-level2.b72bee19.png";